import _ from 'lodash'

let _cache = {}

export default {
  get (path = null) {
    if (!path) {
      return null
    }
    return _.get(_cache, path, null)
  },
  set (path, value = null) {
    if (!path) {
      return
    }
    _.set(_cache, path, value)
  },
  merge (path, partial = null) {
    if (partial === null) {
      return
    }
    _.set(_cache, path, _.merge(_.get(_cache, path), partial))
  },
  clear () {
    _cache = {}
  }
}
// static.thomas.nutsbp.com/nutsbp-config/db/industry.json



// WEBPACK FOOTER //
// ./src/Mem.js